import React from 'react';
import {
  managersRealTimeOptions,
  submittersRealTimeOptions,
} from './options';
import IndeterminateCheckbox from '../../common/IndeterminateCheckbox';
import FormError from '@dealroadshow/uikit-form/FormError';
import { IQuestionsRealtimeNotificationSettingsPayload } from '../../../domain/vo/QuestionsEmailAlerts';
import type { IndeterminateValue } from '../../../domain/vo/IndeterminateValue';
import styles from './realTime.module.scss';

interface IProps<T> {
  isQuestionManager: boolean,
  values: T,
  initialValues: T,
  realtimeError: string,
  handleChange: (field: keyof T, value: boolean) => void,
}

const RealTime = <T extends IndeterminateValue<IQuestionsRealtimeNotificationSettingsPayload>>({
  isQuestionManager,
  values,
  initialValues,
  handleChange,
  realtimeError,
}: IProps<T>) => {
  const realTimeOptions = isQuestionManager ? managersRealTimeOptions : submittersRealTimeOptions;

  return (
    <div className={ styles.wrapper }>
      { realTimeOptions.map(({
        name,
        label,
        dataTest,
      }) => (
        <IndeterminateCheckbox
          key={ name }
          name={ name }
          dataTest={ dataTest }
          label={ label }
          initialValue={ initialValues[name] }
          value={ values[name] }
          className={ styles.checkbox }
          onChange={ (value) => handleChange(name as keyof T, value) }
        />
      )) }
      <FormError error={ realtimeError } touched />
    </div>
  );
};

export default RealTime;
